export function canAddVendorToBidEvent(vendor, bidTeams) {
  if (!vendor || !vendor.supplierId || !Array.isArray(bidTeams)) {
    return false;
  }

  // return true if vendorId not in any bid teams supplier list
  return !isVendorOnBidEvent(vendor, bidTeams);
}

export function canAddVendorToPortal(vendor, supplierGroups) {
  if (!vendor || !vendor.supplierId || !Array.isArray(supplierGroups)) {
    return false;
  }

  // return true if vendorId not in any supplier group supplier list
  return !isVendorOnPortal(vendor, supplierGroups);
}

///

export function isVendorOnBidEvent(vendor, bidTeams) {
  if (!vendor || !vendor.supplierId || !Array.isArray(bidTeams) || !bidTeams.length) {
    return false;
  }

  // return true if vendorId is in any bid teams supplier list
  return bidTeams.some(bidTeam => bidTeam.suppliers[vendor.supplierId]);
}

export function isVendorOnPortal(vendor, supplierGroups) {
  if (!vendor || !vendor.supplierId || !Array.isArray(supplierGroups) || !supplierGroups.length) {
    return false;
  }

  // return true if vendorId is in any supplier group supplier list
  return supplierGroups.some(supplierGroup => supplierGroup.suppliers[vendor.supplierId]);
}
